<h1 mat-dialog-title>Oops</h1>
<div mat-dialog-content>
  <p>{{ errorMessage }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
